import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownOption } from '../../shared/components/mat-dropdown/mat-dropdown.component';
import { SCREEN_LOCK_NEVER_ID } from '../../shared/components/screen-lock-configuration/screen-lock-configuration.interface';

@Injectable({ providedIn: 'root' })
export class DashboardRefreshIntervalService {
  public readonly minuteAbbreviation = this.translateService.instant('general.minuteAbbreviated');
  public readonly hourAbbreviation = this.translateService.instant('general.shortHour');
  public readonly refreshDataIntervalOptions = [
    { id: -1, name: this.translateService.instant('general.never') },
    {
      id: 0,
      name: this.translateService.instant('general.dashboardDependent'),
    },
    { id: 60, name: `1 ${this.minuteAbbreviation}` },
    { id: 120, name: `2 ${this.minuteAbbreviation}` },
    { id: 180, name: `3 ${this.minuteAbbreviation}` },
    { id: 240, name: `4 ${this.minuteAbbreviation}` },
    { id: 300, name: `5 ${this.minuteAbbreviation}` },
    { id: 900, name: `15 ${this.minuteAbbreviation}` },
    { id: 1800, name: `30 ${this.minuteAbbreviation}` },
    { id: 2700, name: `45 ${this.minuteAbbreviation}` },
    { id: 3600, name: `1 ${this.hourAbbreviation}` },
  ] as const;

  /** Screen lock idle durations. A preset list, like the refresh intervals above: a mistyped free number here would mean a board that re-locks every two seconds. */
  public readonly autoLockDurationOptions: IDropdownOption[] = [
    { id: SCREEN_LOCK_NEVER_ID, name: this.translateService.instant('general.never') },
    { id: 30, name: `30 ${this.translateService.instant('field.seconds')}` },
    { id: 60, name: `1 ${this.minuteAbbreviation}` },
    { id: 300, name: `5 ${this.minuteAbbreviation}` },
    { id: 900, name: `15 ${this.minuteAbbreviation}` },
    { id: 1800, name: `30 ${this.minuteAbbreviation}` },
    { id: 3600, name: `1 ${this.hourAbbreviation}` },
  ];

  constructor(private readonly translateService: TranslateService) {}
}
